import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const RECENT_BUYERS = [{
  name: 'Martín G.',
  location: 'Buenos Aires',
  combo: 'Combo 2',
  gender: 'male',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Sofía L.',
  location: 'Córdoba',
  combo: 'Combo 2',
  gender: 'female',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Lucas M.',
  location: 'Rosario',
  combo: 'Combo 3',
  gender: 'male',
  avatar: 'https://randomuser.me/api/portraits/men/45.jpg'
}, {
  name: 'Valentina R.',
  location: 'Mendoza',
  combo: 'Combo 3',
  gender: 'female',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Juan P.',
  location: 'La Plata',
  combo: 'Combo 2',
  gender: 'male',
  avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Camila S.',
  location: 'Mar del Plata',
  combo: 'Combo 2',
  gender: 'female',
  avatar: 'https://randomuser.me/api/portraits/women/25.jpg'
}, {
  name: 'Diego F.',
  location: 'Tucumán',
  combo: 'Combo 3',
  gender: 'male',
  avatar: 'https://randomuser.me/api/portraits/men/67.jpg'
}, {
  name: 'María E.',
  location: 'Salta',
  combo: 'Combo 2',
  gender: 'female',
  avatar: 'https://randomuser.me/api/portraits/women/52.jpg'
}, {
  name: 'Roberto A.',
  location: 'Santa Fe',
  combo: 'Combo 3',
  gender: 'male',
  avatar: 'https://randomuser.me/api/portraits/men/55.jpg'
}, {
  name: 'Ana C.',
  location: 'Neuquén',
  combo: 'Combo 3',
  gender: 'female',
  avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
}];
export function PurchasePopup() {
  const [currentBuyer, setCurrentBuyer] = useState<(typeof RECENT_BUYERS)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    const showNextBuyer = () => {
      const randomBuyer = RECENT_BUYERS[Math.floor(Math.random() * RECENT_BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      setTimeout(showNextBuyer, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-176">
      {isVisible && currentBuyer && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-3 left-3 z-40 bg-white px-3 py-2.5 rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.25)] max-w-[260px] flex items-center gap-2.5 border border-gray-100" data-id="element-177">
          <img src={currentBuyer.avatar} alt={currentBuyer.name} className="w-8 h-8 rounded-full object-cover border-[1.5px] border-green-500 flex-shrink-0" data-id="element-178" />
          <div data-id="element-179">
            <p className="text-xs font-bold text-gray-900 leading-tight" data-id="element-180">
              {currentBuyer.name}{' '}
              <span className="inline-flex items-center gap-0.5 text-green-600 font-medium text-[9px]" data-id="element-181">
                <CheckCircle2 className="w-2.5 h-2.5" data-id="element-182" />
                verificada
              </span>
            </p>
            <p className="text-[10px] text-gray-500 leading-tight" data-id="element-183">
              de {currentBuyer.location}
            </p>
            <p className="text-[10px] text-green-600 font-semibold leading-tight" data-id="element-184">
              compró el {currentBuyer.combo}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}